import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OptionPhotoModel } from 'src/app/models/option-photo.model';
import { ImageService } from 'src/app/services/image-service/image.service';

@Component({
    selector: 'app-mm-image-preview',
    templateUrl: './mm-image-preview.component.html',
    styleUrls: ['./mm-image-preview.component.scss'],
})
export class MmImagePreviewComponent implements OnInit {

    optionPhoto: OptionPhotoModel;

    constructor(public imageService: ImageService,
        private modalCtrl: ModalController) { }

    async ngOnInit() {

        await this.imageService.cameraPreview(this.optionPhoto.positionCamera);

    }

    touchCloseModal() {
        this.modalCtrl.dismiss();
    }

}
